export class WidgetWindowResizeController {
    constructor(options) {
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "boundaryController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                enforceConstraints: () => { },
            }
        });
        this.options = options;
        this.boundaryController = options.boundaryController;
        this.handlers = {
            enforceConstraints: () => {
                this.boundaryController.updateViewportDimensions();
                const position = this.options.getWidgetPosition();
                const size = this.options.getWidgetSize();
                this.options.enforceConstraints(position, size);
            },
        };
    }
    initialize() {
        if (!this.isInitialized) {
            window.addEventListener('resize', this.handlers.enforceConstraints);
            this.isInitialized = true;
        }
    }
    cleanup() {
        if (this.isInitialized) {
            window.removeEventListener('resize', this.handlers.enforceConstraints);
            this.isInitialized = false;
        }
    }
}
//# sourceMappingURL=WidgetWindowResizeController.js.map